import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "redux/store";
import { getUserProfile } from "../redux/slice/rfpModuleSlice/application";
import { getCookie } from "utils/utils";
import WebSocketProvider from "api/websocket";
import Loading from "style-guide/component/Loader";

interface ProtectedRouteProps {
  component: React.ComponentType;
  allowUnauthenticatedPaths?: string[];
}

  const isPublicPath = (path: string, allowPaths: string[]) => {
  return allowPaths.some(allowed => {
    if (allowed.includes(":")) {
      const regex = new RegExp(
        `^${  allowed.replace(/:[^/]+/g, "[^/]+")  }$`
      );
      return regex.test(path);
    }
    return allowed === path;
  });
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: WrappedComponent,
  allowUnauthenticatedPaths = [],
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();

  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const { userProfile } = useSelector((state: RootState) => state.applicationData);

  useEffect(() => {
    const isAuthorised = Boolean(getCookie("token"));
    const isPublic = isPublicPath(location.pathname, allowUnauthenticatedPaths);

    if (!isAuthorised && isPublic) {
      setIsAuthenticated(true);
      return;
    }

    if (!isAuthorised && !isPublic) {
      setIsAuthenticated(false);
      navigate("/");
      return;
    }

    const fetchUser = async () => {
      try {
        if (!userProfile?.userDetails?.length) {
          await dispatch(getUserProfile());
        }
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
        navigate("/");
      }
    };

    fetchUser();
  }, [dispatch, navigate, location.pathname, userProfile]);

  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loading />
      </div>
    );
  }

  return isAuthenticated ? (
    <WebSocketProvider>
      <WrappedComponent />
    </WebSocketProvider>
  ) : null;
};

export default ProtectedRoute;
